import request from "@/utils/request";
let baseUrl = '/proxyapi';
// 求职者登录
export function jobseekerLogin(query) {
    return request({
        url: baseUrl + '/home/auth/jobseekerLogin',
        method: 'post',
        data: query
    })
}

// 企业登录
export function companyLogin(query) {
    return request({
        url: baseUrl + '/home/auth/companyLogin',
        method: 'post',
        data: query
    })
}
// 退出登录
export function logout() {
    return request({
        url: baseUrl + '/home/auth/logout',
        method: 'post',
    })
}

// 第三方登录 绑定并登录
export function Bindlogout(data) {
    return request({
        url: baseUrl + "/home/oauth/bind/login",
        method: 'post',
        data: data
    })
}
// 第三方登录 注册并登录
export function signlogout(data) {
    return request({
        url: baseUrl + '/home/oauth/sign/login',
        method: 'post',
        data: data
    })
}